import { AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, Input, OnDestroy, OnInit } from '@angular/core';

import { forEach } from 'lodash';

import { WorkShiftStatus } from '../../employee-statuses/employee-work-statuses/employee-work-statuses.component';
import { EmployeeStatusesService } from '../../employee-statuses/employee-statuses.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AuthService } from '../../../../../auth/auth.service';

@Component({
  selector: 'app-monitoring-work-statuses',
  templateUrl: './monitoring-work-statuses.component.html',
  styleUrls: ['./monitoring-work-statuses.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class MonitoringWorkStatusesComponent implements OnInit, AfterViewInit, OnDestroy {
  public moment = require('moment');
  public statuses: WorkShiftStatus[] = [];

  private _workStatuses;

  @Input()
  set workStatuses(statuses) {
    if (!statuses) {
      return;
    }
    this._workStatuses = statuses;
    this.makeStatuses(statuses);
  }
  get workStatuses() {
    return this._workStatuses;
  }
  @Input() ticketId;
  @Input() workday;

  get isGRS() {
    return this.authService.isGRSUser();
  }

  private destroy$ = new Subject<void>();

  constructor(
    private elementRef: ElementRef,
    private employeeStatusesService: EmployeeStatusesService,
    private cdr: ChangeDetectorRef,
    private authService: AuthService
  ) {}

  ngOnInit() {
    this.employeeStatusesService.isAddData
      .pipe(takeUntil(this.destroy$))
      .subscribe((state: boolean) => {
        if (state) {
          this.makeStatuses(this.workStatuses);
        }
      });
  }

  getClass(intType: number) {
    return this.isGRS ? `interval-item--grs--${intType}` : `interval-item--${intType}`;
  }

  ngAfterViewInit() {
    this.makeStatuses(this.workStatuses);
  }

  getId(s) {
    return btoa(s.int_begin + s.int_end + s.int_type);
  }

  private makeStatuses(workStatuses) {
    setTimeout(() => {
      forEach(workStatuses, (s) => {
        let status = {
          uid: this.getId(s),
          int_begin: s.int_begin,
          int_end: s.int_end,
          int_type: s.int_type,
          style: {width: null, left: null},
          isIntermediate: false,
        };
        let hoursStart = +this.moment(s.int_begin).format('HH');
        let minutesStart = +this.moment(s.int_begin).format('mm');
        let hoursEnd = +this.moment(s.int_end).format('HH');
        let minutesEnd = +this.moment(s.int_end).format('mm');
        let grandParent = this.elementRef.nativeElement.parentElement.parentElement;

        let childStarts = grandParent.querySelectorAll(
          'div[id="ticket_' + this.ticketId + '_' + this.workday + '_' + hoursStart + '"]'
        );
        let childEnds = grandParent.querySelectorAll(
          'div[id="ticket_' + this.ticketId + '_' + this.workday + '_' + hoursEnd + '"]'
        );

        let childStart = Array.prototype.find.call(childStarts,
          (child) => this.employeeStatusesService.isToday(child, s.int_begin)
        );
        let childEnd = Array.prototype.find.call(childEnds,
          (child) => this.employeeStatusesService.isToday(child, s.int_end)
        );

        if (childStart && childEnd) {
          let st = (childStart.clientWidth / 60) * minutesStart;
          let ed = (childEnd.clientWidth / 60) * minutesEnd;
          let wh = childEnd.offsetLeft + ed - (childStart.offsetLeft + st);

          let workInterval = this.elementRef.nativeElement.querySelector('.work-interval');
          status.style.left = childStart.offsetLeft + st + 'px';
          status.style.width = wh - 1 + 'px';

          // Фейковая подгонка перекрестного интервала двух дней, чтобы скрыть проблему интервала в 2 px,
          // также убрать бордеры
          if (hoursStart === 23 && minutesStart === 59 && hoursEnd === 0 && minutesEnd === 0) {
            workInterval.isIntermediate = true;
          }

          const exists = this.statuses.find((wss: WorkShiftStatus) => wss.uid === status.uid);
          if (!exists) {
            this.statuses.push(status);
          }
        }
      });

      this.cdr.markForCheck();
    }, 4);
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
